export default __webpack_public_path__ + "static/gardening_service-1185b37946c70bb5d3eb459bb3f67a9d.jpg";